import { render } from "./CustomersPage.vue?vue&type=template&id=51f69fa0&ts=true"
import script from "./CustomersPage.vue?vue&type=script&lang=ts"
export * from "./CustomersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__